import PageLayout from 'pages/AccountSettings/PageLayout';
import PageProvider from 'pages/AccountSettings/PageProvider';

const AccountSettings = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default AccountSettings;
